import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import styles from "./BlockedBadge.module.css";
import { getBlockReasonTranslation } from "../utils/blockReason";
export var BlockedBadge = function (_a) {
    var blocked = _a.blocked, blockReason = _a.blockReason, blockComment = _a.blockComment;
    var intl = useIntl();
    if (!blocked) {
        return null;
    }
    var reasonText = getBlockReasonTranslation(intl, blockReason);
    return (React.createElement("span", { className: styles.blockedBadgeWrapper },
        React.createElement("span", { className: styles.blockedBadge },
            React.createElement(FormattedMessage, { id: "ui-br-agency.product-number.badge.blocked" })),
        reasonText && (React.createElement("span", { className: styles.blockReason, title: blockComment || undefined }, reasonText))));
};
